/** Keyboard alternative to drawing; the worker still confirms and submits the declaration. */
export function typedSignatureDataUrl(name: string): string {
  const canvas = document.createElement('canvas');
  canvas.width = 720;
  canvas.height = 220;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Your signature could not be prepared. Try again.');
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = '#202127';
  context.font = 'italic 52px "Source Sans 3", sans-serif';
  context.textBaseline = 'middle';
  context.fillText(name.trim(), 42, canvas.height / 2, canvas.width - 84);
  return canvas.toDataURL('image/png');
}
